import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Message } from 'primeng/api/message';
import { environment } from 'src/environments/environment';
import { SessionApiService } from '../services/auth/session-api.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../login/login.component.scss'],
})
export class ForgotPasswordComponent {
  environment = environment;
  msgs: Message[] = [];
  loading = false;
  sent = false;

  frm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    private sessionApi: SessionApiService,
    private title: Title
  ) {
    this.title.setTitle(`${environment.softwareName} - Password dimenticata`);
  }

  submit() {
    if (this.frm.invalid || this.loading) return;
    this.loading = true;
    this.msgs = [];
    this.sessionApi.forgotPassword((this.frm.get('email')!.value ?? '').trim()).subscribe({
      next: () => {
        this.loading = false;
        this.sent = true;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        const message = error.error?.message;
        this.msgs = [
          {
            severity: 'error',
            summary: 'Attenzione',
            detail:
              error.status === 0
                ? 'Impossibile contattare il server. Controlla la connessione.'
                : typeof message === 'string' && message
                  ? message
                  : 'Non è stato possibile inviare la richiesta, riprova.',
          },
        ];
      },
    });
  }
}
